import {Injectable} from '@angular/core';
import {AuthService, Campaign, OrganizationType, RedeemedCampaign, RestClientService} from 'shared-lib';
import {map, Observable} from 'rxjs';
import {UserRewardsSum} from '../../../../shared-lib/src/lib/services/model';
import {UserReward} from './models/user-reward';

@Injectable({
  providedIn: 'root'
})
export class UserCampaignService {

  constructor(private restClient: RestClientService, private authService: AuthService) {
  }

  public getRedeemedCampaign(campaignId: string): Observable<RedeemedCampaign> {
    const userId = this.authService.getCurrentUser()!.id;
    return this.restClient.get<RedeemedCampaign>(`/loyalty/users/${userId}/campaigns/${campaignId}/redeemed`)
      .pipe(map(redeemedCampaign => {
        return {...redeemedCampaign, campaign: this.enhanceOrganization(redeemedCampaign.campaign)}
      }));
  }

  public getUserRewardsSum(): Observable<UserRewardsSum> {
    const userId = this.authService.getCurrentUser()!.id;
    return this.restClient.get<UserRewardsSum>(`/loyalty/users/${userId}/campaigns/redeemed/sum`);
  }

  public getUserRewardsList(): Observable<UserReward[]> {
    const userId = this.authService.getCurrentUser()!.id;
    return this.restClient.get<UserReward[]>(`/loyalty/users/${userId}/campaigns/redeemed`);
  }


  //TODO most probably organization should be removed form campaing view.
  private enhanceOrganization(campaign: Campaign): Campaign {
    return {
      ...campaign, organization: {
        ...campaign.organization,
        isSponsor() {
          return campaign.organization!.type === OrganizationType.SPONSOR || campaign.organization!.type === OrganizationType.SPONSOR_WITH_MCARD;
        },
        isMerchant() {
          return campaign.organization!.type === OrganizationType.MERCHANT;
        }
      }
    }
  }

}

